/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconBase } from '../IconBase.js';
import { IconName } from '../IconName.enum.js';

const ErrorIcon = forwardRef((props, ref) => {
    const { className = '', title, strokeWidth = 1.5 } = props;
    return (jsx(IconBase, Object.assign({ ref: ref, className: className, title: title, name: IconName.Error }, { children: jsx("path", { strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", d: "m4.93 4.93 14.14 14.14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z" }) })));
});

export { ErrorIcon };
//# sourceMappingURL=ErrorIcon.js.map
